import { render, staticRenderFns } from "./detailPage.component.vue?vue&type=template&id=5ffed92e&"
import script from "./detailPage.component.vue?vue&type=script&lang=js&"
export * from "./detailPage.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports